import { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';
import { Button, Spinner } from 'react-bootstrap';

const StatusButton = ({action,successMessage = 'Success!',defaultFailMessage = 'A problem occured.',primaryText = '',refreshFunction,...props}) => {
    // const [showStatus,setShowStatus] = useState(false);
    const [isDisabled,setIsDisabled] = useState(false);

    const containerRef = useRef();

    const _buttonStep = {
        Initial : 0,
        Confirm : 1,
        Action : 2,
        SuccessFinal: 3,
        ErrorFinal: 4
    }

    const [buttonState,setButtonState] = useState(_buttonStep.Initial);

    const _handleClick = (currentButtonStep) => {
        switch(currentButtonStep){
            case _buttonStep.Confirm:
                setIsDisabled(true);
                setButtonState(_buttonStep.Action);
                action()
                .then(() =>{
                    setButtonState(_buttonStep.SuccessFinal);
                    if(refreshFunction){
                        refreshFunction();
                    }
                    setTimeout(() => {
                        setIsDisabled(false);
                        setButtonState(_buttonStep.Initial);
                    }, (3000));
                }).catch(() => {
                    setButtonState(_buttonStep.ErrorFinal);
                    setTimeout(() => {
                        setIsDisabled(false);
                        setButtonState(_buttonStep.Initial);
                    }, 3000);
                })
                break;
            case _buttonStep.Initial:
                setButtonState(_buttonStep.Confirm);
                break;
            default:
                break;
        }
    }

      const _renderButtonState = (buttonStep) => {
        switch(buttonStep){
            case _buttonStep.Confirm:
                return(
                    <>Are you sure?</>
                )
            case _buttonStep.Action:
                return(
                    <Spinner animation='border' size='sm' />
                )
            case _buttonStep.SuccessFinal:
                return(
                    <>
                        <FontAwesomeIcon icon={faCheckCircle} size='xl' style={{color: 'green'}}/>
                        <strong className='ms-1'>{successMessage}</strong>
                    </>
                )
            case _buttonStep.ErrorFinal:
                return(
                    <>
                        <FontAwesomeIcon icon={faXmarkCircle} size='xl' style={{color: 'green'}}/>
                        <strong className='ms-1'>{defaultFailMessage}</strong>
                    </>
                )
            default:
                return <>{primaryText}</>
        }
      }

      useEffect(() => {
        const handleOutsideClick = (event) => {
            if(containerRef.current && !containerRef.current.contains(event.target)){
                setButtonState((prev) => {
                    if (prev === _buttonStep.Confirm){
                        return _buttonStep.Initial;
                    }
                    else{
                        return prev;
                    }
                });
            }
        }
  
        document.addEventListener('mousedown',handleOutsideClick);
  
        return () => {
            document.removeEventListener('mousedown',handleOutsideClick);
        };
    },[containerRef]);
    
    
    return(
        <Button type='button' onClick={() => _handleClick(buttonState)} disabled={isDisabled} {...props} ref={containerRef}>
            {_renderButtonState(buttonState)}
        </Button>

    )
}

export default StatusButton;